import company_contact_config from "@/components/CompanyContact/config";

export default {
  singleLabel: "Entreprise",
  storeNamespace: 'company',
  authFeature: 'company',
  listRouteName: "CompanyList",
  newRouteName: "CompanyNew",
  editRouteName: "CompanyEdit",
  detailRouteName: "CompanyDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'CompanyForm',
  hideActionCsvButton: true,
  hideActionPdfButton: true,
  titleField: 'name',
  sortBy: 'name',
  showExtendedFilters: true,
  fields: [{
      name: 'name',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: false,
    },
    {
      name: 'company_type_id',
      label: "Type",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
    },
    {
      name: 'company_type',
      label: "Type",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      extendedFilter: true,
      inDetail: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'company_group_id',
      label: "Groupe",
      type: 'select',
      inForm: true,
      required: true,
      inList: false,
      inDetail: false,
    },
    {
      name: 'company_group',
      label: "Groupe",
      type: 'select',
      inForm: false,
      inList: true,
      sortable: true,
      extendedFilter: true,
      inDetail: true,
      formatter: (context, value) => value && value.name ? value.name : null
    },
    {
      name: 'internal_code',
      label: "Code SAP",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'address',
      label: "Adresse",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'email',
      label: "Email",
      type: 'email',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      link: (context, value) => value ? 'mailto:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="mailto:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'email_secondary',
      label: "Email secondaire",
      type: 'email',
      inForm: true,
      required: false,
      inList: false,
      sortable: true,
      filterIn: true,
      inDetail: true,
      link: (context, value) => value ? 'mailto:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="mailto:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'phone_number',
      label: "Téléphone",
      type: 'tel',
      inForm: true,
      required: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      link: (context, value) => value ? 'tel:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="tel:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'phone_number_secondary',
      label: "Téléphone secondaire",
      type: 'tel',
      inForm: true,
      required: false,
      inList: false,
      sortable: true,
      filterIn: true,
      inDetail: true,
      link: (context, value) => value ? 'tel:' + value : null,
      isHtml: true,
      formatter: (context, value) => value ? '<a href="tel:' + value + '">' + value + '</a>' : null
    },
    {
      name: 'fax_number',
      label: "Fax",
      type: 'tel',
      inForm: true,
      required: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
    },
    {
      name: 'tracking_link',
      label: "Lien de tracking",
      type: 'url',
      inForm: true,
      inDetail: true,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      inPdfExport: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'company_contacts',
      label: "Contacts",
      type: 'list',
      icone: 'id-card',
      config: company_contact_config,
      fields: ['fullname', 'email', 'phone_number', 'cellphone_number', 'function']
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/Company/config.js